import React from "react";
import { Formik } from "formik";
import { Button, Form, Grid, Header, Segment } from "semantic-ui-react";
import Alerts from "utilities/Alerts";
import http from "utilities/http";
import ProductInput from "./Inputs/ProductInput";
import QuantityInput from "./Inputs/QuantityInput";
import PaidCheckBox from "./Inputs/PaidCheckBox";
import stockSalesReturn from "validators/stockSalesReturn";

function AddPurchaseReturn() {
	const submitDamagedStock = async (values, handlers) => {
		try {
			const response = await http({
				method: "POST",
				url: "/stock/purchase-return",
				data: {
					...values,
				},
			});

			const { message } = response.data;

			Alerts.success(message);
			handlers.resetForm();
		} catch (ex) {
			Alerts.httpException(ex);
		}
	};
	return (
		<>
			<Formik
				initialValues={{
					productId: "",
					quantity: "",
					invoiceNo: "",
					paid: true,
				}}
				onSubmit={submitDamagedStock}
				validationSchema={stockSalesReturn}
			>
				{({
					values,
					errors,
					touched,
					handleSubmit,
					handleChange,
					handleBlur,
					isSubmitting,
				}) => (
					<Form onSubmit={handleSubmit}>
						<Header as="h2">Add Purchase Return Record</Header>
						<Segment loading={isSubmitting}>
							<Form.Input
								name="invoiceNo"
								placeholder="XXXX-XXXXX"
								value={values.invoiceNo}
								onChange={handleChange}
								onBlur={handleBlur}
								label="Invoice No."
							>
								<input />
								<PaidCheckBox
									icon={values.paid ? "check" : "x"}
									content="Paid?"
									{...(values.paid ? { color: "teal" } : {})}
								/>
							</Form.Input>
							<p style={{ color: "red" }}>
								{errors.invoiceNo &&
									touched.invoiceNo &&
									errors.invoiceNo}
							</p>
							<Grid
								columns={2}
								style={{
									marginTop: "0px",
									marginBottom: "0px",
								}}
							>
								<Grid.Column>
									<ProductInput />
								</Grid.Column>
								<Grid.Column>
									<QuantityInput />
								</Grid.Column>
							</Grid>
							<Button type="submit" positive>
								Add Record
							</Button>
						</Segment>
					</Form>
				)}
			</Formik>
		</>
	);
}

export default AddPurchaseReturn;
